import type { ReactNode } from "react";

import { Action, classNames } from "./Primitives";
import { layoutStyles, surfaceStyles } from "./style-config";

export default function CatalogTemplate({
  filters,
  count,
  countLabel,
  children,
  isEmpty,
  emptyMessage,
  onReset,
}: {
  filters: ReactNode;
  count: number;
  countLabel: string;
  children: ReactNode;
  isEmpty: boolean;
  emptyMessage: string;
  onReset: () => void;
}) {
  return (
    <div>
      <details className="border-y border-burgundy/25 py-4 lg:hidden">
        <summary className="cursor-pointer font-neueheitz text-2xl">
          Filter & sort
        </summary>
        <div className="pt-6">{filters}</div>
      </details>

      <div className={layoutStyles.filterLayout}>
        <aside className="hidden lg:sticky lg:top-28 lg:block">{filters}</aside>
        <div>
          <p aria-live="polite" className="pb-6 text-lg font-[700]">
            {count} {countLabel}
          </p>
          {!isEmpty ? (
            <div className={layoutStyles.catalogGrid}>{children}</div>
          ) : (
            <div className={classNames(surfaceStyles.clay, "p-8")}>
              <h3 className="font-neueheitz text-fluid-base">{emptyMessage}</h3>
              <Action
                variant="text"
                onClick={onReset}
                className="mt-5 text-sand"
              >
                Reset filters
              </Action>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
